import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { TableMemoryPort } from '@festo-ax/smartenance-shared-ui';
import { GlobalTableMemoryStore } from './global-table-memory.store';

/**
 * Binds `TableMemoryPort` to {@link GlobalTableMemoryStore}, replacing the
 * library's default in-process `Map`.
 *
 * Register once in the root injector, or on a `Route` to scope it —
 * `EnvironmentProviders` is not valid in a component's `providers`.
 */
export function provideTableMemory(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: TableMemoryPort,
      useExisting: GlobalTableMemoryStore,
    },
  ]);
}
